export default "__VITE_PUBLIC_ASSET__542c5027__"